import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Columns from './Columns';
import RowLabels from './RowLabels';
import Labels from './Labels';

export default function BipolarHorizontal({ rows, labels, minWidth }) {
  return (
    <div className="answers">
      {rows.map((row, index) => (
        <Fragment>
          <div
            id={row.id}
            className="answer--bipolar bipolar-horizontal scrollbox"
            data-row-order={index}
          >
            <RowLabels rowLabels={row.rowLabels} minWidth={minWidth} />
            <Columns columns={row.columns} minWidth={minWidth} />
            <Labels labels={labels} minWidth={minWidth} />
          </div>
          <div className="divider margin-md-btm"></div>
        </Fragment>
      ))}
    </div>
  );
}

BipolarHorizontal.propTypes = {
  rows: PropTypes.array,
  labels: PropTypes.array,
  minWidth: PropTypes.number,
};
